import Matter from "../../entities/matter";

/**
 * Matter actions
 *
 * Call order:
 *
 * MATTER_SAVE_QUEUE:	adds the item to the save queue
 * --> MATTER_SAVE:	modifies the state
 * --> MATTER_SAVE_SUCCESS: if all went well
 * --> MATTER_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail MATTER_SAVE_QUEUE is during the call to MATTER_SAVE,
 * as adding an item to the queue should never fail.
 */

export const MATTER_FETCH_ONE_QUEUE: any = 'MATTER_FETCH_ONE_QUEUE';
export const MATTER_FETCH_SUCCESS: any = 'MATTER_FETCH_SUCCESS';
export const MATTER_FETCH_FAILURE: any = 'MATTER_FETCH_FAILURE';
export const MATTER_FETCH_ONE_SUCCESS: any = 'MATTER_FETCH_ONE_SUCCESS';
export const MATTER_FETCH_ONE_FAILURE: any = 'MATTER_FETCH_ONE_FAILURE';

export const MATTER_SAVE: any = 'MATTER_SAVE';
export const MATTER_SAVE_QUEUE: any = 'MATTER_SAVE_QUEUE';
export const MATTER_SAVE_SUCCESS: any = 'MATTER_SAVE_SUCCESS';
export const MATTER_SAVE_FAILURE: any = 'MATTER_SAVE_FAILURE';

export const MATTER_SAVE_MANY: any = 'MATTER_SAVE_MANY';
export const MATTER_SAVE_MANY_QUEUE: any = 'MATTER_SAVE_MANY_QUEUE';
export const MATTER_SAVE_MANY_SUCCESS: any = 'MATTER_SAVE_MANY_SUCCESS';
export const MATTER_SAVE_MANY_FAILURE: any = 'MATTER_SAVE_MANY_FAILURE';

export const MATTER_REMOVE: any = 'MATTER_REMOVE';
export const MATTER_REMOVE_QUEUE: any = 'MATTER_REMOVE_QUEUE';
export const MATTER_REMOVE_SUCCESS: any = 'MATTER_REMOVE_SUCCESS';
export const MATTER_REMOVE_FAILURE: any = 'MATTER_REMOVE_FAILURE';

export const MATTER_RESTORE: any = 'MATTER_RESTORE';
export const MATTER_RESTORE_QUEUE: any = 'MATTER_RESTORE_QUEUE';
export const MATTER_RESTORE_SUCCESS: any = 'MATTER_RESTORE_SUCCESS';
export const MATTER_RESTORE_FAILURE: any = 'MATTER_RESTORE_FAILURE';

export const MATTER_RESTORE_MANY: any = 'MATTER_RESTORE_MANY';
export const MATTER_REMOVE_MANY: any = 'MATTER_REMOVE_MANY';

/* Fetch actions */
export const fetchMatterSuccess = (matters: Matter[], partial: boolean, lastFetch: number) => ({type: MATTER_FETCH_SUCCESS, matters, partial, lastFetch});
export const fetchMatterFailure = (err: any) => {
		console.error('MatterAction: fetchMatterFailure', err);
		return {type: MATTER_FETCH_FAILURE, err};
};
export const fetchOneMatterQueue = (matterId: string) => ({type: MATTER_FETCH_ONE_QUEUE, matterId});
export const fetchOneMatterSuccess = (matter: Matter) => ({type: MATTER_FETCH_ONE_SUCCESS, matter});
export const fetchOneMatterFailure = (id: string, err: any) => {
		console.error('MatterAction: fetchOneMatterFailure', err);
		return {type: MATTER_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveMatter = (matter: Matter) => {
    // console.debug('⮂ MATTER_SAVE action', matter?.id);
    return {type: MATTER_SAVE, matter};
}
export const saveMatterQueue = (matter: Matter, onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ MATTER_SAVE_QUEUE action', matter?.id);
    return {type: MATTER_SAVE_QUEUE, matter, onQueued};
}
export const saveMatterSuccess = (matter: Matter) => {
    // console.debug('⮂ MATTER_SAVE_SUCCESS action', matter?.id);
    return {type: MATTER_SAVE_SUCCESS, matter};
}
export const saveMatterFailure = (matter: Matter, status: number, message: string) => {
    console.warn(`⮂ MATTER_SAVE_FAILURE error saving matter: HTTP ${status}: ${message}`, matter?.id);
    return {type: MATTER_SAVE_FAILURE, matter, status, message};
};

/* SaveMany actions */
export const saveManyMatters = (matters: Matter[]) => {
    // console.debug('⮂ MATTER_SAVE_MANY action', matters?.map(matter => matter?.id).join(','));
    return {type: MATTER_SAVE_MANY, matters};
}
export const saveManyMattersQueue = (matters: Matter[], onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ MATTER_SAVE_MANY_QUEUE action', matters?.map(matter => matter.id).join(','));
    return {type: MATTER_SAVE_MANY_QUEUE, matters, onQueued};
}

export const saveManyMattersSuccess = (matters: Matter[]) => {
    // console.debug('⮂ MATTER_SAVE_MANY_SUCCESS action', matters?.map(matter => matter.id).join(','));
    return {type: MATTER_SAVE_MANY_SUCCESS, matters};
}
export const saveManyMattersFailure = (matters: Matter[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_MATTERS_FAILURE Error saving matters: HTTP ${status}: ${message}`, matters?.map(matter => matter.id).join(','));
		return {type: MATTER_SAVE_MANY_FAILURE, matters, status, message};
};

/* Remove actions */
export const removeMatter = (matter: Matter) => ({ type: MATTER_REMOVE, matter });
export const removeMatterQueue = (matter: Matter) => ({ type: MATTER_REMOVE_QUEUE, matter });
export const removeMatterSuccess = (matter: Matter) => ({ type: MATTER_REMOVE_SUCCESS, matter });
export const removeMatterFailure = (matter: Matter, status: number, message: string) => {
	console.error(`Redux: removeMatterFailure Error removing matter: HTTP ${status}: ${message}`);
	return ({ type: MATTER_REMOVE_FAILURE, matter, status, message });
};

/* Restore actions */
export const restoreMatter = (matter: Matter) => ({ type: MATTER_RESTORE, matter });
export const restoreMatterQueue = (matter: Matter) => ({ type: MATTER_RESTORE_QUEUE, matter });
export const restoreMatterSuccess = (matter: Matter) => ({ type: MATTER_RESTORE_SUCCESS, matter });
export const restoreMatterFailure = (matter: Matter, status: number, message: string) => {
	console.error(`Redux: restoreMatterFailure Error restoring matter: HTTP ${status}: ${message}`);
	return ({ type: MATTER_RESTORE_FAILURE, matter, status, message });
};

/* RestoreMany actions */
export const restoreManyMatters = (matters: Matter[]) => ({ type: MATTER_RESTORE_MANY, matters });

/* RemoveMany actions */
export const removeManyMatters = (matters: Matter[]) => ({ type: MATTER_REMOVE_MANY, matters });